'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _webComponents = require('@vezeeta/web-components');

var _Tabs = require('./Tabs.styles');

var _IconsStore = require('../../../../IconsStore');

var _IconsStore2 = _interopRequireDefault(_IconsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      extended: false,
      shouldHide: false,
      itemsToShow: 5,
      count: 0,
      tabs: _this.props.tabs
    }, _this.getLoadingTab = function (index) {
      return _react2.default.createElement(
        _Tabs.TabLoading,
        { justifyContent: 'center', alignItems: 'center', key: index },
        _react2.default.createElement(_webComponents.Circle, { radius: 18 })
      );
    }, _this.calculateShouldHide = function (tabs) {
      if (!(tabs && tabs.length)) {
        _this.setState({
          extended: false,
          shouldHide: false,
          count: 0
        });
        return;
      }
      var itemsToShow = _this.state.itemsToShow;

      if (tabs.length > itemsToShow - 1) {
        _this.setState({ shouldHide: true, count: tabs.length });
      } else {
        _this.setState({ shouldHide: false, count: tabs.length });
      }
    }, _this.toggleExtended = function (state) {
      var newState = void 0;
      var extended = _this.state.extended;

      if (state !== undefined && state !== null) {
        newState = state;
      } else {
        newState = !extended;
      }
      _this.props.toggoleExpantion(state);
      _this.setState({ extended: newState });
    }, _this.trackOnTabClick = function (tabName) {
      var accountTypes = {
        1: 'Single Dr',
        2: 'Polyclinic'
      };
      var _this$props = _this.props,
          mixpanel = _this$props.mixpanel,
          userRole = _this$props.userRole,
          user = _this$props.user;
      var EntitySignUpTypeId = user.EntitySignUpTypeId;

      mixpanel.track(tabName + ' Module', {
        'Account Type': EntitySignUpTypeId && accountTypes[EntitySignUpTypeId],
        'User Role': userRole
      });
    }, _this.renderitem = function (item, userCountryId) {
      var language = _this.props.language;

      if (language && item && item.enable && userCountryId && item.countries && item.countries.length) {
        if (item.countries.includes(userCountryId) && _IconsStore2.default.getIcon(item.icon)) {
          var isActiveModule = _this.props.activeTab === item.Key;
          return _react2.default.createElement(
            _Tabs.Tab,
            {
              isActive: isActiveModule,
              isArabic: _this.props.language !== 'en',
              href: window && window.PROJECTS_URLS[item.Key],
              key: item.title + '-' + item.title,
              onClick: function onClick() {
                return _this.trackOnTabClick(item.Key);
              }
            },
            item.icon && _react2.default.createElement(_webComponents.Icon, {
              icon: _IconsStore2.default.getIcon(item.icon),
              color: isActiveModule ? '#0070CD' : '#7E7E7E',
              width: item.iconSize
            }),
            item[language] && _react2.default.createElement(
              _Tabs.TabName,
              { isActive: isActiveModule },
              item[language]
            )
          );
        }
      }
      return '';
    }, _this.renderTabs = function (tabs) {
      // eslint-disable-next-line no-unused-vars
      var _this$state = _this.state,
          itemsToShow = _this$state.itemsToShow,
          extended = _this$state.extended,
          shouldHide = _this$state.shouldHide;
      var user = _this.props.user;


      var isMobile = window.innerWidth <= 1023;
      var items = void 0;
      if (isMobile && tabs.sideNavigstionItems.length) {
        items = tabs.sideNavigstionItems.map(function (tab) {
          return _this.renderitem(tab, user.CountryId);
        });
        var mobileView = _react2.default.createElement(
          _Tabs.TabsMobileViewContainerWrapper,
          null,
          !extended && _react2.default.createElement(
            _Tabs.Tab,
            { onClick: function onClick() {
                return _this.toggleExtended(true);
              } },
            _react2.default.createElement(_webComponents.Icon, { icon: _IconsStore2.default.getIcon('expand'), color: '#7E7E7E', width: 20 })
          ),
          _react2.default.createElement(
            _Tabs.TabsMobileViewContainer,
            null,
            items
          ),
          extended && _react2.default.createElement(
            _Tabs.Tab,
            { onClick: function onClick() {
                return _this.toggleExtended(false);
              } },
            _react2.default.createElement(_webComponents.Icon, { icon: _IconsStore2.default.getIcon('collapse'), color: '#7E7E7E', width: 20 })
          )
        );
        return mobileView;
      }
      items = tabs.sideNavigstionItems.map(function (tab) {
        return _this.renderitem(tab, user.CountryId);
      });
      return items;
    }, _this.renderLazyLoadingTabs = function () {
      var loadingTabs = [];
      var isMobile = window.innerWidth <= 1023;
      for (var counter = 0; counter < 7; counter += 1) {
        loadingTabs.push(_this.getLoadingTab(counter));
      }

      return _react2.default.createElement(
        _webComponents.ShimmerEffect,
        { flexDirection: isMobile ? 'row' : 'column' },
        loadingTabs
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Tabs.prototype.componentDidMount = function componentDidMount() {
    var tabs = this.props.tabs;
    var count = this.state.count;

    if (!tabs || count !== tabs.length) {
      this.calculateShouldHide(tabs);
    }
  };

  Tabs.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var tabs = props.tabs;


    if (tabs && tabs.length !== state.tabs.length) {
      return { tabs: tabs };
    }
    return null;
  };

  Tabs.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var tabs = prevProps.tabs;

    if (tabs !== this.props.tabs) {
      this.calculateShouldHide(this.props.tabs);
    }
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        tabs = _props.tabs,
        isLoading = _props.isLoading,
        language = _props.language;
    var itemsToShow = this.state.itemsToShow;

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _Tabs.TabContainerParent,
        { language: language },
        _react2.default.createElement(
          _Tabs.TabsContainer,
          { tabs: tabs.length >= itemsToShow ? itemsToShow : tabs.length },
          isLoading ? this.renderLazyLoadingTabs() : this.renderTabs(tabs)
        )
      )
    );
  };

  return Tabs;
}(_react.Component);

Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  tabs: _propTypes2.default.object.isRequired,
  activeTab: _propTypes2.default.string.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  toggoleExpantion: _propTypes2.default.func.isRequired,
  language: _propTypes2.default.string.isRequired,
  user: _propTypes2.default.object.isRequired,
  mixpanel: _propTypes2.default.object.isRequired,
  userRole: _propTypes2.default.string.isRequired
} : {};

exports.default = Tabs;
module.exports = exports['default'];